<div class="container padding-bottom-3x mb-2">
  <div class="row">

    <div class="col-md-4">
      <app-user-info-wrapper></app-user-info-wrapper>

    </div>

    <div class="col-md-8">
      <div class="padding-top-2x mt-2 hidden-lg-up"></div>
      <h4>{{'Temple'|translate}} {{'Address'|translate}}</h4>
      <hr class="padding-bottom-1x">
      <form autocomplete="off" class="row">
        <div class="col-md-6">
          <div class="mb-3">
            <label for="account-company">Company</label>
            <input class="form-control" type="text" id="account-company" value="Bets Company Ltd.">
          </div>
        </div>
        <div class="col-md-6">
          <div class="mb-3">
            <label for="account-country">Country</label>
            <select class="form-control" id="account-country">
              <option>Choose country</option>
              <option>Australia</option>
              <option>Canada</option>
              <option>France</option>
              <option>Germany</option>
              <option>Switzerland</option>
              <option selected="">United States</option>
            </select>
          </div>
        </div>
        <div class="col-md-6">
          <div class="mb-3">
            <label for="account-city">City</label>
            <select class="form-control" id="account-city">
              <option>Choose city</option>
              <option>Amsterdam</option>
              <option>Berlin</option>
              <option>Geneve</option>
              <option selected="">New York</option>
              <option>Paris</option>
            </select>
          </div>
        </div>
        <div class="col-md-6">
          <div class="mb-3">
            <label for="account-zip">ZIP {{'Code'|translate}}</label>
            <input class="form-control" type="text" id="account-zip" required="">
          </div>
        </div>
        <div class="col-md-6">
          <div class="mb-3">
            <label for="account-address1">{{'Address'|translate}} 1</label>
            <input class="form-control" type="text" id="account-address1" required="">
          </div>
        </div>
        <div class="col-md-6">
          <div class="mb-3">
            <label for="account-address2">{{'Address'|translate}} 2</label>
            <input class="form-control" type="text" id="account-address2">
          </div>
        </div>
        <div class="col-12 padding-top-1x">
          <!-- <h4>Shipping {{'Address'|translate}}</h4>
        <hr class="padding-bottom-1x"> -->
          <div class="form-check d-block">
            <!-- <input class="form-check-input" type="checkbox" id="same_address" checked="">
          <label class="form-check-label" for="same_address">Same as Contact {{'Address'|translate}}</label> -->
          </div>
          <!-- <hr class="margin-top-1x margin-bottom-1x"> -->
          <div class="text-end">
            <button class="btn btn-primary margin-bottom-none" type="button" data-toast="" data-toast-position="topRight" data-toast-type="success"
              data-toast-icon="icon-circle-check" data-toast-title="Success!" data-toast-message="Your address updated successfuly.">Update {{'Address'|translate}}</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>